import { Button, Spinner } from "@shared/components";
import { MIN_LOGIN_CHARS, MIN_PASS_CHARS } from "@shared/constants/app";
import { useUserState } from "@shared/hooks/user";
import cx from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { useIntl } from "react-intl";
import { Field, reduxForm, SubmissionError } from "redux-form";

const renderField = (values) => {
  const {
    input,
    label,
    type,
    meta: { touched, error, warning },
  } = values;
  const message = error || warning;

  return (
    <div
      className={cx("form__item", {
        "form__item--error": !!(touched && error),
        "form__item--warning": !!(touched && warning),
      })}
    >
      <input
        {...input}
        placeholder={label}
        type={type}
        className="form__input"
      />
      {touched && message && <div className="form__message">{message}</div>}
    </div>
  );
};

const AuthForm = ({ loading, handleSubmit, onAuthEnter }) => {
  const intl = useIntl();
  const { error } = useUserState();
  const validateAuth = (values) => {
    let { username = "", password = "" } = values;

    username = username.trim();
    password = password.trim();

    if (!username || username.length < MIN_LOGIN_CHARS) {
      throw new SubmissionError({
        username: intl.formatMessage({
          id: "boilerplate.components.Popup.LoginIncorrect",
        }),
      });
    }

    if (!password || password.length < MIN_PASS_CHARS) {
      throw new SubmissionError({
        password: intl.formatMessage({
          id: "boilerplate.components.ModalRoom.PasswordFillError",
        }),
      });
    }

    onAuthEnter(username, password);
  };

  return (
    <form
      className="dropdown__section form"
      onSubmit={handleSubmit(validateAuth)}
    >
      <Field
        name="username"
        type="text"
        component={renderField}
        label={intl.formatMessage({
          id: "boilerplate.components.Popup.PlaceholderSignIn",
        })}
      />
      <Field
        name="password"
        type="password"
        component={renderField}
        label={intl.formatMessage({
          id: "password",
        })}
      />
      <div
        style={{ minHeight: "40px" }}
        className="form__item grid__item grid__item_null"
      >
        {loading ? (
          <Spinner />
        ) : (
          <Button
            type="submit"
            variant="primary"
            className="grid__item_5"
            tagName="button"
          >
            {intl.formatMessage({ id: "sign-in" })}
          </Button>
        )}
      </div>
      {error?.message?.length > 0 && (
        <div className="form__message form__item--error form__message--error form__message--no-margin">
          {intl.formatMessage({
            id: error.message,
          })}
        </div>
      )}
    </form>
  );
};

AuthForm.propTypes = {
  onAuthEnter: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "AuthForm",
})(AuthForm);
